export default __webpack_public_path__ + "static/media/132.e5a92e6e.png";